import { useEffect } from "react";
import "./KeepInTouch.css";
import { subscribe } from "../../../api/endpoints";
import { VALIDATION_RULES, VALIDATION_MESSAGE } from "../../../constants";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { useSelector, useDispatch } from "react-redux";
import {
  setRequestInProgress,
  setRequestSuccess,
  setRequestFailure,
  setRequestInit,
} from "../../../redux/Slices/RequestFormSlice";

let formTypePayload = { type: "homePageNewsLetter" };

const validationSchema = yup.object().shape({
  email: yup
    .string()
    .required(VALIDATION_MESSAGE.EMAIL.REQUIRED)
    .email(VALIDATION_MESSAGE.EMAIL.INVALID),
});

function KeepInTouch() {
  const { homePageNewsLetter } = useSelector((state) => state.requestForm);
  const dispatch = useDispatch();

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({
    mode: "all",
    resolver: yupResolver(validationSchema),
  });

  const handleFormSubmit = async (formData) => {
    try {
      dispatch(setRequestInProgress(formTypePayload));
      const {
        status,
        data: { msg },
      } = await subscribe(formData.email);
      if (status === 200) {
        formTypePayload = { ...formTypePayload, successMessage: msg };
        dispatch(setRequestSuccess(formTypePayload));
        reset();
        setTimeout(() => {
          dispatch(setRequestInit(formTypePayload));
        }, 3000);
      } else {
        formTypePayload = { ...formTypePayload, errorMessage: msg };
        dispatch(setRequestFailure(formTypePayload));
        setTimeout(() => {
          dispatch(setRequestInit({ type: "homePageNewsLetter" }));
        }, 3000);
      }
    } catch (error) {
      const {
        response: {
          data: { msg },
        },
      } = error;
      formTypePayload = { ...formTypePayload, errorMessage: msg };
      dispatch(setRequestFailure(formTypePayload));
      setTimeout(() => {
        dispatch(setRequestInit({ type: "homePageNewsLetter" }));
      }, 3000);
    }
  };

  useEffect(()=>{
    dispatch(setRequestInit(formTypePayload));
  },[])

  return (
    <section className="keep-in-touch-long">
      <div className="container spacer-y">
        <div className="row">
          <div className="col-lg-6">
            <div className="keep-form white-bg">
              <h2>Keep In Touch</h2>
              <p className="text-muted mt-2">
                We will keep you updated and informed on new episodes, products,
                and all the things.
              </p>
              <form onSubmit={handleSubmit(handleFormSubmit)} noValidate>
                <input
                  {...register("email")}
                  readOnly={homePageNewsLetter?.loader}
                  type="email"
                  name="email"
                  className="form-control theme-form mt-4"
                  placeholder="Email Address"
                />
                <div className="text-left">
                  {errors.email && (
                    <span style={{ color: "#CA2132", fontSize: "14px" }}>
                      {errors.email.message}
                    </span>
                  )}
                  {Object.keys(errors).length === 0 &&
                  homePageNewsLetter?.errorMessage ? (
                    <span className="text-danger">
                      {homePageNewsLetter?.errorMessage}
                    </span>
                  ) : (
                    ""
                  )}
                  {Object.keys(errors).length === 0 &&
                  homePageNewsLetter?.successMessage ? (
                    <span className="text-success">
                      {homePageNewsLetter?.successMessage}
                    </span>
                  ) : (
                    ""
                  )}
                </div>

                <button
                  disabled={homePageNewsLetter?.loader}
                  type="submit"
                  className="form-control theme-button mt-4"
                >
                  {homePageNewsLetter?.loader ? "Please wait..." : "Subscribe"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default KeepInTouch;
